// extracted by mini-css-extract-plugin
module.exports = {"root":"HomePage_root___4-GS","row":"HomePage_row__3i8pc","crossplatformImg":"HomePage_crossplatformImg__Zxlsf"};